<div class="flex flex-column">

  <div class="flex gap-3">
    <div class="flex flex-column">
      <label class="font-medium mb-2">{{'common.from' | transloco}}</label>
      <p-calendar
        [(ngModel)]="startDate"
        [style]="{'min-width': '150px'}"
        [showTime]="timePeriod === 'HOURLY'"
        [showWeek]="timePeriod === 'WEEKLY'"
        [view]="timePeriod === 'MONTHLY' ? 'month' : 'date'"
        [maxDate]="currentDate"
        [readonlyInput]="true"
        [disabledDays]="timePeriod === 'WEEKLY' ? [0,2,3,4,5,6] : undefined"
        firstDayOfWeek="1"
        dateFormat="dd/mm/yy"
        appendTo="body"
      ></p-calendar>
    </div>
    <div class="flex flex-column">
      <label class="font-medium mb-2">{{'common.to' | transloco}}</label>
      <p-calendar
        [(ngModel)]="endDate"
        [style]="{'min-width': '150px'}"
        [showTime]="timePeriod === 'HOURLY'"
        [showWeek]="timePeriod === 'WEEKLY'"
        [view]="timePeriod === 'MONTHLY' ? 'month' : 'date'"
        [maxDate]="currentDate"
        [readonlyInput]="true"
        [disabledDays]="timePeriod === 'WEEKLY' ? [0,2,3,4,5,6] : undefined"
        firstDayOfWeek="1"
        dateFormat="dd/mm/yy"
        appendTo="body"
      ></p-calendar>
    </div>
  </div>

  <div class="mt-4 flex justify-content-between">
    <button
      [label]="'common.cancel' | transloco"
      (click)="cancel()"
      pButton
      pRipple
      class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
    ></button>
    <button
      [label]="'misc.recalculate' | transloco"
      (click)="save()"
      pButton
      pRipple
      icon="pi pi-history"
      class="mt-2 sm:mt-0 sm:flex-order-0"
    ></button>
  </div>

</div>
